export default {
    title: "Kevi | Order Status",
    page_title: "Order Status",
    approved: "Approved",
    pending: "Pending",
    cancelled: "Cancelled",
    save: "Save",
    success_message: "Status updated",
    external_label_column: "External status",
    kevi_status_column: "Kevi status",
    repurchase_reference_column: "Repurchase reference",
    repurchase_reference_help:
        "The repurchase reference defines when a product's repurchase time starts counting. With no status checked, counting starts at the order creation date. When you check one or more statuses, an approved order only starts counting once it reaches the first checked status (for example, \"delivered\"), using the time Kevi detected that change. Changing this selection rebuilds predictions on the next nightly run.",
};
